module.exports = __webpack_public_path__ + "static/online-03affc16c01eb963649aac7181a72c5d.svg";